<template>
  <AdminLayout>
    <DetailForm
      v-if="loaded"
      title="Edit"
      description="This form will edit a advertising budget request"
      action="Save"
      @handleCancel="$router.go(-1)"
      @handleAction="handleSubmit"
    >
      <DateInput label="Start Date" :modelValue="budget_request.start_date" @update:modelValue="updateStartDate" />
      <DateInput label="End Date" :modelValue="budget_request.end_date" @update:modelValue="updateEndDate" />
      <CurrencyInput
        label="Indeed Spend"
        :modelValue="budget_request.indeed_spend"
        @update:modelValue="updateIndeedSpend"
      />
      <CurrencyInput label="Zip Spend" :modelValue="budget_request.zip_spend" @update:modelValue="updateZipSpend" />
      <CurrencyInput
        label="Monster Spend"
        :modelValue="budget_request.monster_spend"
        @update:modelValue="updateMonsterSpend"
      />
      <CurrencyInput label="Meta Spend" :modelValue="budget_request.meta_spend" @update:modelValue="updateMetaSpend" />
      <SelectMenu
        label="Status"
        :options="['rejected', 'pending', 'completed']"
        :initialValue="budget_request.status"
        @selectedOption="budget_request.status = $event"
      />
    </DetailForm>
  </AdminLayout>
</template>

<script>
import AdminLayout from '../AdminLayout/index.vue';
import DetailForm from '../shared/DetailForm.vue';

export default {
  props: ['record'],
  components: {
    AdminLayout,
    DetailForm,
  },
  data() {
    return {
      budget_request: {
        start_date: '',
        end_date: '',
        indeed_spend: 0,
        zip_spend: 0,
        monster_spend: 0,
        meta_spend: 0,
        status: '',
      },
      loaded: false,
    };
  },
  mounted() {
    this.getContact();
  },
  methods: {
    getContact() {
      const self = this;
      self.$store.commit('general/showLoadingSpinner');
      fetch(`/api/admin/monthly_marketing_budget_update_requests/${self.$route.params.id}`)
        .then(response => {
          self.$store.commit('general/hideLoadingSpinner');
          return response.json();
        })
        .then(data => {
          self.budget_request = data.record;
          self.loaded = true;
        });
    },
    updateStartDate(value) {
      this.budget_request.start_date = value;
    },
    updateEndDate(value) {
      this.budget_request.end_date = value;
    },
    updateIndeedSpend(value) {
      this.budget_request.indeed_spend = value;
    },
    updateZipSpend(value) {
      this.budget_request.zip_spend = value;
    },
    updateMonsterSpend(value) {
      this.budget_request.monster_spend = value;
    },
    updateMetaSpend(value) {
      this.budget_request.meta_spend = value;
    },
    handleSubmit() {
      const self = this;
      self.$store.commit('general/showLocalLoadingSpinner');
      fetch(`/api/admin/monthly_marketing_budget_update_requests/${self.$route.params.id}`, {
        method: 'PUT',
        body: JSON.stringify({
          start_date: self.budget_request.start_date,
          end_date: self.budget_request.end_date,
          indeed_spend: self.budget_request.indeed_spend,
          zip_spend: self.budget_request.zip_spend,
          monster_spend: self.budget_request.monster_spend,
          meta_spend: self.budget_request.meta_spend,
          status: self.budget_request.status,
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => {
          return response.json();
        })
        .then(async data => {
          self.$store.commit('general/hideLocalLoadingSpinner');
          if (data.status != 'error') {
            await self.$router.push(`/admin/budget_requests?sort=created&order=desc&status=Pending`);
            self.$store.commit('general/showAlert', {
              alertType: 'success',
              alertTitle: 'Advertising Budget Request edited',
              alertDescription:
                'Your Advertising Budget Request was successfully edited.  Use the button below to dismiss this alert.',
            });
          } else {
            self.$store.commit('general/showAlert', {
              alertType: 'error',
              alertTitle: 'Advertising Budget Request edit error',
              alertDescription: data.message,
            });
          }
        });
    },
  },
};
</script>
